import { Loader2, Camera } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

function Thumb({ which, p, active, onPick }) {
  if (!p) {
    return (
      <div data-testid={`photo-${which}-missing`} className="flex-1 aspect-[4/5] rounded border border-border flex items-center justify-center font-mono-t text-[9px] text-slate-600 text-center p-1">
        No {which} photo in window
      </div>
    );
  }
  const cloudy = p.cloud_pct >= 50;
  return (
    <button data-testid={`photo-${which}`} onClick={onPick}
      className={`flex-1 rounded border overflow-hidden text-left transition-colors ${active ? "border-cyan" : "border-border hover:border-slate-500"}`}>
      <img src={`${API}${p.url}`} alt={`${which} storm`} className="w-full aspect-[4/5] object-cover bg-slate-900" loading="lazy" />
      <div className="px-1.5 py-1 font-mono-t text-[9px] leading-tight">
        <div className="text-slate-200 uppercase">{which} · {p.date}</div>
        <div data-testid={`photo-${which}-cloud`} className={cloudy ? "text-amber-300" : "text-emerald-300"}>
          {p.cloud_pct}% cloud · {p.days_from_event > 0 ? `+${p.days_from_event}` : p.days_from_event} d
        </div>
      </div>
    </button>
  );
}

export default function PhotoStrip({ photos, view, setView }) {
  return (
    <div data-testid="photo-strip" className="space-y-1.5">
      <div className="flex items-center gap-1.5 font-mono-t text-[9px] uppercase tracking-wider text-slate-500">
        <Camera className="w-3 h-3" /> Sentinel-2 colour photos
        <button data-testid="view-radar" onClick={() => setView("radar")}
          className={`ml-auto px-1.5 rounded border ${view === "radar" ? "border-sky-400/60 text-sky-300" : "border-border text-slate-500"}`}>
          Radar
        </button>
      </div>
      {(!photos || photos.status === "running") && (
        <div data-testid="photos-running" className="flex items-center gap-2 font-mono-t text-[10px] text-slate-400">
          <Loader2 className="w-3 h-3 animate-spin" /> Finding the least cloudy days…
        </div>
      )}
      {photos?.status === "error" && <div data-testid="photos-error" className="font-mono-t text-[10px] text-risk-critical">{photos.message}</div>}
      {photos?.status === "no_scene" && <div className="font-mono-t text-[10px] text-slate-500">No Sentinel-2 scenes in the window</div>}
      {photos?.status === "ok" && (
        <div className="flex gap-1.5">
          <Thumb which="before" p={photos.before} active={view === "before"} onPick={() => setView("before")} />
          <Thumb which="after" p={photos.after} active={view === "after"} onPick={() => setView("after")} />
        </div>
      )}
    </div>
  );
}
